import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Collapsible from 'react-collapsible';
import { DateTimeFormatters } from '@showclix-shared-intl';
import PriceLevelWrapper from './PriceLevelWrapper';
import BundlesContainer from '../../bundle-picker/containers/BundlesContainer';
import ProductWrapper from '../../product-picker/containers/ProductWrapper';
import BundleContainer from '../../bundle-picker/containers/BundleContainer';
import PriceLevelContainer from './PriceLevelContainer';
import ProductContainer from '../../product-picker/containers/ProductContainer';
import { isKioskMode, getCustomInventory, isAlwaysShowHiddenLevels } from 'checkout/selectors/ui';
import { showBestAvailablePicker } from 'checkout/selectors/reserved-seating';
import { getFetchedEventBundles, getFetchedEventPriceLevels, getFetchedEventProducts, getMainEvent } from '../../../selectors/event';
import { selectedPresaleSeriesChild, getSeriesChildOnsaleDate, unlockedSelectedPresaleSeriesChild } from '../../series/selectors/eventSeries';
import ChangeDateContainer from './ChangeDateContainer';
import { InventoryItemsSkeleton } from '../components/InventoryItemsSkeleton';
import { createLoadingSelector } from '../../../selectors/helpers';
import TicketAnnouncer from '../components/TicketAnnouncer';
import Translation from '@s/Translation';

const FieldSetWrap = ({ children }) => (
    <fieldset>
        <legend className="sr-only"><Translation>{'checkout__inventory_legend'}</Translation></legend>
        {children}
    </fieldset>
);

class InventoryItemsContainer extends Component {

    constructor(props) {
        super(props);

        let openedHeaders = {};
        let bodyOpen = {};

        if(this.props.itemOrder) {
            for(let i = 0; i < this.props.itemOrder.length; i++) {
                openedHeaders[i] = this.props.itemOrder[i].collapsed;
                bodyOpen[i] = this.props.itemOrder[i].collapsed;
            }
        }

        this.state = { openedHeaders, bodyOpen };
    }

    isLoading = () => {
      return this.props.childEventLoading || this.props.eventTimesLoading || this.props.seriesCalendarLoading
    }

    render() {
        if (this.isLoading()) {
          return <InventoryItemsSkeleton />;
        }

        // if opening ticket picker to pre_sale event from series, show the on sale date
        if (this.props.selectedPresaleSeriesChild && !this.props.unlockedSelectedPresaleSeriesChild) {
            let onsaleMessage = '';
            const { fullDateShort } = DateTimeFormatters;
            if (this.props.seriesChildOnsaleDate) {
                onsaleMessage = "Tickets go on sale " + fullDateShort(this.props.locale, this.props.seriesChildOnsaleDate);
            }
            return (
                <div className="tickets__list">
                    <strong>{onsaleMessage}</strong>
                </div>);
        }

        if (this.props.itemOrder && !this.props.showBestAvailablePicker) {
            return this.renderCustomOrder();
        }

        return this.renderDefaultOrder();
    }

    renderDefaultOrder = () => {
        if (this.props.isKiosk) {
            return(
                <FieldSetWrap>
                    <TicketAnnouncer />
                    {this.props.children}
                    <ProductWrapper />
                    <BundlesContainer />
                </FieldSetWrap>
            )
        }
        return (
            <FieldSetWrap>
                <TicketAnnouncer />
                <PriceLevelWrapper showBestAvailablePicker={this.props.showBestAvailablePicker}/>
                <ProductWrapper />
                <BundlesContainer />
            </FieldSetWrap>
        )
    }

    renderCustomOrder = () => {
        let prepend = [];
        prepend.push(<TicketAnnouncer />);
        if (this.props.isKiosk && this.props.isSeries) {
            prepend.push(<div className="tickets__list" key="-1"><h4><ChangeDateContainer /></h4></div>);
        }
        const prependResult = prepend.concat(this.props.itemOrder.map((group, i) => {
            return <Fragment key={i}>
                {/* Collapsible with Title */}
                {(group.collapsed === true && group.title !== "") &&
                <div className="tickets__list tickets__list--collapsible">
                    <button id={"custom-inventory-button--" + (i)} className="collapsible__button button--clear" role="button" aria-controls={"custom-inventory--" + (i)} tabIndex="0" aria-expanded={this.state.bodyOpen[i] ? 'false' : 'true'}  onClick={this.toggleHeader(i)}>
                        <h2 className={"ticket__header tickets__group-title tickets__group-trigger" + (this.state.bodyOpen[i] ? ' body-hidden' : ' body-visible')} >
                            <i className="collapsible__indicator-arrow icon-keyboard_arrow_down" aria-hidden="true"></i>
                            {group.title}
                        </h2>
                    </button>
                    <Collapsible
                        open={this.state.openedHeaders[i] === false}
                        transitionTime={250}
                        easing={"ease-in-out"}
                        contentInnerClassName="collapsible-inventory__content--inner"
                        contentOuterClassName="collapsible-inventory__content--outer"
                    >
                        <div
                            id={"custom-inventory--" + (i)}
                            role="region"
                            aria-labelledby={"custom-inventory-button--" + (i)}
                            hidden={this.state.bodyOpen[i] ? 'hidden' : ''}
                        >
                            {this.renderItems(group.contents)}
                        </div>
                    </Collapsible>
                </div>
                }
                {/* Non Collaspible w/ Title */}
                {(!group.collapsed && group.title !== "") &&
                <div className="tickets__list">
                    <h2 className="ticket__header tickets__group-title body-visible" >{group.title}</h2>
                    {this.renderItems(group.contents)}
                </div>
                }
                {/* No Title (non collapsible only) */}
                {(!group.collapsed && group.title === "") &&
                <div className="tickets__list">
                    {this.renderItems(group.contents)}
                </div>
                }
            </Fragment>
        }));

        return (
          <FieldSetWrap>
            {prependResult}
          </FieldSetWrap>
        )
    }

    renderItems = (items) => {
      
        return items.map((item, i) => {
            if(item.type === "ticket") {
                if (this.props.isSeries) {
                    let childItemId = this.getChildItemIdFromParent(item.id, item.type);
                    return childItemId ? <PriceLevelContainer key={i} levelId={childItemId}/> : null;
                } else {
                    if(!this.props.priceLevels[item.id]) {
                        return null;
                    }
                    if (this.props?.priceLevels[item.id]?.box_office_hide && this.props.isKiosk && !this.props.alwaysShowHiddenLevels) {
                        return null;
                    }
                    if (!this.props?.priceLevels[item.id]?.active && !this.props.isKiosk && !this.props.alwaysShowHiddenLevels) {
                        return null;
                    }
                    return <PriceLevelContainer key={i} levelId={item.id}/>
                }
            } else if(item.type === 'product') {
                if(!this.props.products[item.id]) {
                    return null;
                }

                return <ProductContainer key={i} productId={item.id}/>
            } else if(item.type === 'bundle') {
                if (this.props.isSeries) {
                    let childItemId = this.getChildItemIdFromParent(item.id, item.type);
                    return childItemId ? <BundleContainer key={i} bundleId={childItemId}/> : null;
                } else {
                    if(!this.props.bundles[item.id]) {
                        return null;
                    }
                    return <BundleContainer key={i} bundleId={item.id}/>
                }
            }
            return null;
        });
    }

    //search the loaded items for the child that corresponds to the parent item id from custom inventory configuration
    getChildItemIdFromParent = (parentItemId, type) => {
        const typeMap = {
            ticket: {items: this.props.priceLevels, id: 'price_level_id'},
            product: {items: this.props.products, id: 'product_id'},
            bundle: {items: this.props.bundles, id: 'id'},
        };
        let childItemId = null;
        Object.values(typeMap[type].items).map(item => {
            if (+item.parent_id === +parentItemId) {
                childItemId = item[typeMap[type].id];
            }
        });
        return childItemId;
    }

    toggleHeader = (i) => {
        return () => {
            if(this.props.itemOrder[i].collapsed === false || this.props.itemOrder[i].title === "") {
                return;
            }

            let headers = {...this.state.openedHeaders};
            let bodies = {...this.state.bodyOpen};
            headers[i] = !headers[i];
            bodies[i] = !bodies[i];
            this.setState({openedHeaders: headers});
            // setTimeOut only on 'closing' the collapsible
            // Gives Collaspible time to transition before using "hidden" on the collapsible content
            // Hidden is used for accessiblity, allows tabbing over closed content
            if(this.state.bodyOpen[i]){
                this.setState({bodyOpen: bodies});
            }else{
                setTimeout(function(){
                    this.setState({bodyOpen: bodies});
               }.bind(this),250);
            }
        }
    }
}

const eventTimesLoading = createLoadingSelector("EVENT_TIMES");
const seriesCalendarLoading = createLoadingSelector("SERIES_CALENDAR");
const selectChildEventLoading = createLoadingSelector("SELECT_CHILD_EVENT");
const mapStateToProps = (state, props) => {
    return {
        locale: state.intl.locale,
        itemOrder: getCustomInventory(state),
        isKiosk: state.ui.uiConfig.layout === "kiosk",
        selectedPresaleSeriesChild: selectedPresaleSeriesChild(state),
        seriesChildOnsaleDate: getSeriesChildOnsaleDate(state),
        unlockedSelectedPresaleSeriesChild: unlockedSelectedPresaleSeriesChild(state),
        isSeries: !!getMainEvent(state)?.event?.isRecurring,
        priceLevels: getFetchedEventPriceLevels(state),
        products: getFetchedEventProducts(state),
        bundles: getFetchedEventBundles(state, undefined),
        showBestAvailablePicker: showBestAvailablePicker(state),
        eventTimesLoading: eventTimesLoading(state),
        seriesCalendarLoading: seriesCalendarLoading(state),
        childEventLoading: selectChildEventLoading(state),
        alwaysShowHiddenLevels: isAlwaysShowHiddenLevels(state),
    };
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators({

    },
    dispatch);
}

InventoryItemsContainer.propTypes = {

}

export default connect(mapStateToProps, mapDispatchToProps)(InventoryItemsContainer)
